import React from "react";
import "./Skeleton.css";

const Skeleton = () => {
  return (
    <div class="w-full flex flex-wrap">
      <span class="skeleton-box h-[180px] w-full mt-1 inline-block rounded-md"></span>
    </div>
  );
};

export default Skeleton;
